// extracted by mini-css-extract-plugin
export default {"container":"List_container__69L8e","placeholderContainer":"List_placeholderContainer__BFc+v"};